export const initScrollAnimations = () => {

    const counters = document.querySelectorAll("[data-count]");

    counters.forEach(counter => {

        const update = () => {

            const target = +counter.getAttribute("data-count");
            const current = +counter.innerText;

            const increment = target / 100;

            if (current < target) {

                counter.innerText = Math.ceil(current + increment);
                setTimeout(update, 20);

            } else {

                counter.innerText = target;

            }

        };

        update();

    });

};